import { Star } from "lucide-react";
import { useSettings } from "../../lib/SettingsContext";

export const Marquee = () => {
  const s = useSettings();
  const items = s.marquee_items || [];

  return (
    <div data-testid="marquee" dir="ltr" className="relative overflow-hidden border-y border-yellow-400/20 bg-yellow-400/[0.04] py-4">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0">
            {items.map((t, i) => (
              <span key={i} className="flex items-center gap-6 px-6 font-display text-base sm:text-lg text-zinc-400 whitespace-nowrap">
                {t}
                <Star className="w-4 h-4 text-yellow-400 shrink-0" fill="currentColor" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
